import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, SignersDialogueHandler } from './type';
import SignersContext from './SignersContext';

const { ConfirmationDialogue } = vp;

type SignersDialogueProps = {
  handleDialogue: DialogueHandler<SignersDialogueHandler>;
};

type FC = FunctionComponent<SignersDialogueProps>;

const SignersDialogue: FC = ({ handleDialogue }: SignersDialogueProps) => {
  const {
    showDeleteSignerConfirmAlert,
    showDeleteSignerErrorAlert,
    deleteSignerError,
    showDeleteSignerAlert,
    showEditSignerAlert,
    shouldShowMaximumSignerAlert,
  } = useContext(SignersContext);

  return useMemo(
    () => (
      <div>
        {/* Delete Signers Confirmation */}
        <ConfirmationDialogue
          isVisible={showDeleteSignerConfirmAlert}
          title={`Are you sure you wish to delete the signer?`}
          subTitle={`All related signer data will be deleted.`}
          status="alert"
          confirm={{
            label: 'Cancel',
            action: () => handleDialogue({ type: 'alertDelete', state: 'back' }),
          }}
          cancel={{
            label: 'Delete Signer ',
            action: () => handleDialogue({ type: 'alertDelete', state: 'confirm' }),
          }}
        />

        {/* Delete Signer Error */}
        <ConfirmationDialogue
          isVisible={showDeleteSignerErrorAlert}
          title="Error! The signer was not deleted."
          status="error"
          subTitle={`${deleteSignerError}`}
          confirm={{
            label: 'Back',
            action: () => handleDialogue({ type: 'delete', state: 'confirm' }),
          }}
        />

        {/* Maximun Signer Alert */}
        <ConfirmationDialogue
          isVisible={shouldShowMaximumSignerAlert}
          title="Exceeding maximum amount of signers"
          status="alert"
          subTitle="Each agreement may only have a maximum of 5 signers. If you wish to add an additional signor, please remove a signor first."
          confirm={{
            label: 'Okay',
            action: () => handleDialogue({ type: 'warning', state: 'confirm' }),
          }}
        />

        {/* Signer Edit Alert */}
        <ConfirmationDialogue
          isVisible={showEditSignerAlert}
          title="Cannot Edit Signer"
          status="alert"
          subTitle="Signer is unable to be edited."
          confirm={{
            label: 'Okay',
            action: () => handleDialogue({ type: 'noEdit', state: 'confirm' }),
          }}
        />

        {/* Signer Delete Alert */}
        <ConfirmationDialogue
          isVisible={showDeleteSignerAlert}
          title="Cannot delete signer"
          status="alert"
          subTitle="Signer is unable to be deleted."
          confirm={{
            label: 'Okay',
            action: () => handleDialogue({ type: 'noDelete', state: 'confirm' }),
          }}
        />
      </div>
    ),
    [
      showDeleteSignerConfirmAlert,
      showDeleteSignerErrorAlert,
      deleteSignerError,
      showEditSignerAlert,
      showDeleteSignerAlert,
      shouldShowMaximumSignerAlert,
    ],
  );
};

export default SignersDialogue;
